import { validateRequired, validateEmail } from '../../../../core/validators';

const composeDirectReferral = {
  to: [validateEmail('to')(), validateRequired('to')()],
  subject: [validateRequired('subject')()],
  message: [validateRequired('message')()],
};

export { composeDirectReferral };
